<div class="col-xs-12 is-rtl-flt">
    <h1 *ngIf="(step$ | async) === OrderStatusStep.CHECK" class="col-xs-12 ttu mb-32 title-l-b is-rtl-flt">
        {{ 'dev.orderStatus.title1' | translate }}
    </h1>
    <h1 *ngIf="(step$ | async) === OrderStatusStep.NOT_FOUND" class="col-xs-12 ttu mb-32 title-l is-rtl-flt">
        {{ 'dev.orderStatus.title3' | translate }}
    </h1>
    <form class="is-flex flex-wrap mb-32" [formGroup]="form" (ngSubmit)="checkOrder()">
        <div class="col-xs-12 col-sm-7 mb-32">
            <div class="form-input-label-2" [class.is-error]="form.controls.order.invalid && form.controls.order.dirty">
                <input
                    id="order"
                    class="form-control input"
                    [placeholder]="'dev.orderStatus.orderId' | translate"
                    type="text"
                    formControlName="order"
                />
                <label class="ttu text-l" for="order">{{ 'dev.orderStatus.orderId' | translate }}</label>
                <validation-error
                    *ngIf="form.controls.order.invalid && form.controls.order.dirty"
                    [controlForm]="form.controls.order"
                    [errorMessageList]="errorMessageList"
                    [numErrors]="1"
                ></validation-error>
                <div class="help">
                    <div class="text-m c-dark-grey">{{ 'dev.orderStatus.orderIdExample' | translate }}</div>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-sm-5">
            <button class="btn btn-primary btn--full btn-separate ttu">
                <span *ngIf="(step$ | async) !== OrderStatusStep.NOT_FOUND">{{ 'dev.orderStatus.consult' | translate }}</span>
                <span *ngIf="(step$ | async) === OrderStatusStep.NOT_FOUND">{{ 'dev.orderStatus.checkBack' | translate }}</span>
                <svg-icon src="arrow-right"></svg-icon>
            </button>
        </div>
    </form>
</div>
